module.exports = __webpack_public_path__ + "media/images/city_img/r_2-b7e7b0debe46ee1179800c3dcd021fca.png";